import React, { Component } from 'react'
import styled from 'styled-components'

import { MdCheck } from 'react-icons/lib/md'
import CtaButtonSm from './CtaButtonSm'

const iconStyle = {
  height: '25px'
}

class WebPricingTable extends Component {
  render() {
    return (
      <WebPricingTableContainer>
        <PricingGrid>
          <div className="placeholder heading" />
          <div className="heading cell" id="software">
            Software Developers
          </div>
          <div className="heading cell " id="enterprise">
            Enterprise
          </div>
          <div className="placeholder" />
          <div className="cell" id="pre-prod">
            Pre-Production
          </div>
          <div className="cell" id="prod">
            Production
          </div>
          <div className="cell" id="turn-key">
            Turn-key Solutions for your Business
          </div>
          <div className="cell" id="resellers">
            Enterprise Software Resellers
          </div>
          <div className="cell" id="pricing" />
          <div className="cell main" id="free">
            <div>
              <h3>Free</h3>
            </div>
          </div>
          <div className="cell main" id="cent">
            <div>
              <h3>.01</h3>
            </div>
          </div>
          <div className="cell main" id="contact-one">
            <div>
              <h3>Contact Us</h3>
            </div>
          </div>
          <div className="cell main" id="contact-two">
            <div>
              <h3>Contact Us</h3>
            </div>
          </div>
          {/*
              Generic Cells not assinged a 'grid area'
              Laid out by the grid algo -- must be in order
            */}
          <div className="placeholder" />
          <div className="cell generic after-pricing">
            <div>
              <p>Up to 1000 transactions per month</p>
            </div>
          </div>
          <div className="cell generic after-pricing">
            <div>
              <p>per transaction</p>
            </div>
          </div>
          <div className="cell generic after-pricing">
            <div>
              <p> </p>
            </div>
          </div>
          <div className="cell generic after-pricing">
            <div>
              <p> </p>
            </div>
          </div>
          <div className="cell generic" id="users">
            Number of Users
          </div>
          <div className="cell generic" id="ten">
            10
          </div>
          <div className="cell generic" id="users-unlimited-one">
            Unlimited
          </div>
          <div className="cell generic" id="users-unlimited-four">
            Unlimited
          </div>
          <div className="cell generic" id="users-unlimited-three">
            Unlimited
          </div>
          <div className="cell generic" id="limits">
            Transaction Limits
          </div>
          <div className="cell generic" id="thousand">
            1000
          </div>
          <div className="cell generic" id="limits-unlimited-one">
            Unlimited
          </div>
          <div className="cell generic" id="limits-unlimited-two">
            Unlimited
          </div>
          <div className="cell generic" id="limits-unlimited-three">
            Unlimited
          </div>
          <div className="cell generic" id="web">
            Web
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="ios">
            iOS
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="android">
            Android
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="branding">
            Custom Branding
          </div>
          <div className="cell generic"> </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="payments">
            Payments
          </div>
          <div className="cell generic"> </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="notifications">
            Notifications
          </div>
          <div className="cell generic">Push, Email</div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="placeholder" />
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
        </PricingGrid>
      </WebPricingTableContainer>
    )
  }
}

export default WebPricingTable

const WebPricingTableContainer = styled.div`
  display: block;

  @media screen and (max-width: 762px) {
    display: none;
  }
`

const PricingGrid = styled.div`
  // Styles, Grid stuff below:
  .cell {
    font-size: 2rem;
    color: #253858;
  }
  .heading {
    font-size: 3rem;
    font-weight: 600;
    background: #707070 !important;
    color: white;
  }

  .heading:nth-child(2) {
    background: #707070 !important;
  }

  .heading:nth-child(1) {
    background: white !important;
  }

  .main {
    & div {
      width: 105%;
      height: 100%;
      margin: 35px 5px 0 5px;
      background: #4eb964 !important;
      border-radius: 5px 5px 0 0;
    }

    & h3 {
      color: white;
      font-size: 3.5rem;
      font-weight: 600;
      justify-self: center;
      margin-top: auto;
    }
  }
  #contact-one,
  #contact-two {
    position: relative;
    & > div > h3 {
      position: relative;
      top: 15px;
    }
  }

  #free,
  #cent {
    & > div > h3 {
      position: relative;
      top: 15px;
    }
  }

  .after-pricing {
    & div {
      width: 105%;
      height: 67%;
      margin: 0 5px 35px 5px;
      background: #4eb964 !important;
      border-radius: 0 0 5px 5px;
      & p {
        color: white;
        margin: 0 auto auto;
        font-size: 1.2rem;
        width: 60%;
      }
    }

    @media screen and (max-width: 712px) {
      & div {
        height: 100%;
        margin: 0 5px 5px 5px;
      }
    }
  }

  // Target the columns!
  div:nth-child(5n - 1) {
    font-size: 1.4rem;
  }
  div:nth-child(5n) {
    background: #f6f6f6;
  }
  div:nth-child(5n + 1) {
    background: white;
  }
  div:nth-child(5n + 2) {
    background: #f6f6f6;
  }
  div:nth-child(5n + 3) {
    background: white;
  }

  //  Pricing Row!
  div:nth-child(10),
  div:nth-child(11),
  div:nth-child(12),
  div:nth-child(13) {
  }
  /*********
  GRID STUFF:
  **********/
  position: relative;
  left: -50px;
  display: grid;
  grid-template-columns: 150px repeat(4, minmax(200px, 1fr));
  grid-template-rows: 50px 100px 100px 100px repeat(9, 50px);
  grid-auto-flow: row;
  grid-column-gap: 20px;
  grid-template-areas:
    '. software software enterprise enterprise'
    '. pre-prod prod turn-key resellers'
    'pricing free cent contact-one contact-two';

  .cell {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  #software {
    grid-area: software;
  }
  #enterprise {
    grid-area: enterprise;
  }
  #pre-prod {
    grid-area: pre-prod;
  }
  #prod {
    grid-area: prod;
  }
  #turn-key {
    grid-area: turn-key;
  }
  #resellers {
    grid-area: resellers;
  }
  #pricing {
    grid-area: pricing;
  }
  #free {
    grid-area: free;
  }
  #cent {
    grid-area: cent;
  }
  #contact-one {
    grid-area: contact-one;
  }
  #contact-two {
    grid-area: contact-two;
  }
`



// WEBPACK FOOTER //
// ./src/components/UI/WebPricingTable.jsx